import { useTranslation } from 'react-i18next'
import { M_Fieldset } from 'src/M_Components'
import { ShipmentChargesFormField } from './ShipmentChargesFormField'

export const ShipmentChargesValues = ({ dataState, setDataState, disabled, style }) => {
    const { t } = useTranslation()

    const multipleOptions = [
        { label: 'Equipment', value: 'E' },
        { label: 'Document', value: 'D' },
        { label: 'Process', value: 'P' },
        { label: 'Weight', value: 'W' },
        { label: 'Measures', value: 'M' },
        { label: 'Percentage', value: 'C' },
        { label: 'Other', value: 'O' },
        { label: 'TEU', value: 'T' },
        { label: 'Quantity', value: 'Q' },
        { label: 'KG 6 DM3', value: 'G' },
        { label: 'K6', value: 'K' },
    ]

    const row1 = [
        {
            display: t('Currency'), required: true, code: 'CurrencyCode', type: 'foreignKey', entity: 'Currency',
            filterField: 'code', labelFields: ['Code'],
            fields: [{ key: 'Code', value: 'CurrencyCode' }, { key: 'Id', value: 'CurrencyId' }],
            favoritesFieldName: 'Currency', favoritesGroupName: 'ShipmentCharges', favoritesVarKey: 'CurrencyCode', favoritesIdKey: 'CurrencyId',
        },
        { display: t('Multiple'), required: true, code: 'Multiple', type: 'select', options: multipleOptions },
    ]

    const row1b = [
        { display: t('Invoice'), code: 'Invoice', type: 'number' },
        { display: t('Quantity'), code: 'Quantity', type: 'number' },
    ]

    const row2 = [
        {
            display: t('LineCurrency'), code: 'LineCurrencyCode', type: 'foreignKey', entity: 'Currency',
            filterField: 'code', labelFields: ['Code'],
            fields: [{ key: 'Code', value: 'LineCurrencyCode' }, { key: 'Id', value: 'LineCurrencyId' }],
            favoritesFieldName: 'LineCurrency', favoritesGroupName: 'ShipmentCharges', favoritesVarKey: 'LineCurrencyCode', favoritesIdKey: 'LineCurrencyId',
        },
        { display: t('LineMultiple'), code: 'LineMultiple', type: 'select', options: multipleOptions },
        { display: t('Manifest'), code: 'Manifest', type: 'number' },
    ]

    return (
        <M_Fieldset
            labelInside
            style={style}
            label={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '20px', marginLeft: '10px' }}>
                    <i className='pi pi-chart-bar' style={{ fontSize: '18px' }} />
                    {t('Values')}
                </div>
            }
            elements={
                <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {row1.map((field, i) => (
                            <ShipmentChargesFormField key={i} fields={field} index={i} data={dataState} setData={setDataState} options={field.options} disabled={disabled} />
                        ))}
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {row1b.map((field, i) => (
                            <ShipmentChargesFormField key={i} fields={field} index={5 + i} data={dataState} setData={setDataState} options={field.options} disabled={disabled} />
                        ))}
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {row2.map((field, i) => (
                            <ShipmentChargesFormField key={i} fields={field} index={10 + i} data={dataState} setData={setDataState} options={field.options} disabled={disabled} />
                        ))}
                    </div>
                </div>
            }
        />
    )
}
